/** Shell nav menu — derived from `shellFeatureManifest.ts`. */
import { SHELL_LOGIN_LABEL, SHELL_LOGIN_PATH, shellManifestNavItems } from './shellFeatureManifest.ts';

export type ShellNavItem = {
  path: string;
  label: string;
  /** Bottom bar label when full `label` would truncate. */
  shortLabel?: string;
};

/** Bottom bar «Más» — not a route. */
export const SHELL_MORE_NAV_PATH = '__shell_more__';

export const SHELL_PRIMARY_NAV_ITEMS: readonly ShellNavItem[] = shellManifestNavItems('primary');

export const SHELL_MORE_NAV_ITEMS: readonly ShellNavItem[] = shellManifestNavItems('more');

/** Mobile bottom bar: primary modules + «Más». */
export const SHELL_BOTTOM_NAV_ITEMS: readonly ShellNavItem[] = [
  ...SHELL_PRIMARY_NAV_ITEMS,
  { path: SHELL_MORE_NAV_PATH, label: 'Más', shortLabel: 'Más' },
];

/** Desktop rail + nav order for transitions. */
export const SHELL_NAV_ITEMS: readonly ShellNavItem[] = [
  ...SHELL_PRIMARY_NAV_ITEMS,
  ...SHELL_MORE_NAV_ITEMS,
];

const MORE_NAV_PATHS = new Set(SHELL_MORE_NAV_ITEMS.map((item) => item.path));

export function isShellMoreNavPath(path: string): boolean {
  return MORE_NAV_PATHS.has(normalizeShellPath(path));
}

export function normalizeShellPath(path: string): string {
  if (!path) return '/';
  if (path.length > 1 && path.endsWith('/')) return path.slice(0, -1);
  return path;
}

const NAV_PATH_ORDER = new Map(SHELL_NAV_ITEMS.map((item, index) => [item.path, index]));

/** Tab order slide direction (M3 shared axis). Unknown paths default to forward. */
export function compareShellNavDirection(fromPath: string, toPath: string): 'forward' | 'back' {
  const from = NAV_PATH_ORDER.get(normalizeShellPath(fromPath));
  const to = NAV_PATH_ORDER.get(normalizeShellPath(toPath));
  if (from === undefined || to === undefined || from === to) return 'forward';
  return to > from ? 'forward' : 'back';
}

const EXTRA_ROUTE_LABELS: Record<string, string> = {
  [SHELL_LOGIN_PATH]: SHELL_LOGIN_LABEL,
};

/** Human label for route announcements (nav items + known extras). */
export function getShellRouteLabel(path: string): string {
  const normalized = normalizeShellPath(path);
  const navItem = SHELL_NAV_ITEMS.find((item) => item.path === normalized);
  if (navItem) return navItem.label;
  return EXTRA_ROUTE_LABELS[normalized] ?? 'Contenido';
}
